module.exports = __webpack_public_path__ + "static/media/cdl.3094ad91.svg";